export const QUERY_NOW_TICK_MS = 60_000;

export function queryNowBucket(now: number): number {
  return now - (now % QUERY_NOW_TICK_MS);
}

export function currentQueryNow(): number {
  return queryNowBucket(Date.now());
}
